
































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import SoapDokterSvc from "@/services/SoapRanapDokter";
import SoapPerawatSvc from "@/services/SoapRanapPerawat";
import { storePasien } from "@/store/modules/pasien";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import SoapRanapStore from "@/store/modules/SoapRanapStore";
import moment from "moment";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { storeSoap } from "@/store/modules/soap";
import CpptRanapStore from "@/store/modules/CpptRanapStore";
import axios from "axios";
import SoapRanapDokter from "@/services/SoapRanapDokter";
import CpptListContent from "./CpptListContent.vue";

@Component({
  components: {
    CpptListContent
  }
})
export default class CpptIntegratedList extends Vue {
  @Prop({ default: "all" }) readonly showOnly?: "ranap" | "ralan" | "all";
  @Prop({ default: true }) readonly showVerifButton?: boolean;
  @Prop({ default: false }) readonly readonly?: boolean;
  @Prop({ default: false }) readonly canDownload?: boolean;
  // Ralan pakai kode unit < "30": paksa muat ADIME/HandOver/ReadBack yang biasanya
  // hanya di-load untuk unit Ranap/IGD. Default false → Ranap tak berubah.
  @Prop({ default: false }) readonly loadAllCppt?: boolean;
  @Prop({ default: null }) readonly register?: number;
  @Prop({ default: [] }) readonly list?: Array<{
    type: string;
    data: any;
    examined_at: string;
  }>;

  sortAscending = false;
  loadingCppt = false;

  async mounted() {
    if (!this.readonly) {
      this.fetchData();
    }
  }

  @Watch("register")
  changedRegister(val) {
    if (val) {
      this.fetchData();
    }
  }

  get isDokter() {
    return ["Dokter", "Psikolog"].includes(this.stateUser.profesi);
  }

  get isPerawat() {
    return ["Perawat", "Bidan"].includes(this.stateUser.profesi);
  }

  get showGenerateBtn() {
    return userModule.isMedis && this.soapList?.length < 1;
  }

  get soapList() {
    let list = [];
    if (this.showOnly != "all") {
      list = SoapRanapStore.soapList.filter(soap => {
        if (this.showOnly == "ralan") {
          return soap.unit_id < "50";
        } else if (this.showOnly == "ranap") {
          return soap.unit_id >= "30";
        }
      });
    } else {
      list = SoapRanapStore.soapList;
    }

    return list.map(itm => {
      itm["is_verified_ontime"] =
        moment(itm.verified_at).diff(itm.examined_at, "hours") <= 24;
      itm["verified_color"] = itm["is_verified_ontime"] ? "black" : "red";

      return itm;
    });
  }

  get cpptList(): Array<{
    type: string;
    data: any;
    examined_at: string;
  }> {
    const soap = this.soapList.map(it => {
        return {
          type: "soap",
          data: it,
          examined_at: it.examined_at
        };
      }),
      adime = this.adimeList.map(it => {
        return {
          type: "adime",
          data: it,
          examined_at: it.examined_at
        };
      }),
      readback = this.readbackList.map(it => {
        return {
          type: "readback",
          data: it,
          examined_at: it.consulting_at
        };
      }),
      handover = this.handoverList.map(it => {
        return {
          type: "handover",
          data: it,
          examined_at: it.transferred_at
        };
      });

    const list = [...soap, ...adime, ...readback, ...handover].sort((a, b) => {
      const timeA = new Date(a.examined_at).getTime();
      const timeB = new Date(b.examined_at).getTime();
      return this.sortAscending ? timeA - timeB : timeB - timeA;
    });

    if (this.list.length > 0) {
      return this.list;
    } else {
      return list;
    }
  }

  get adimeList() {
    return CpptRanapStore.adimeList;
  }

  get readbackList() {
    return CpptRanapStore.readbackList;
  }

  get handoverList() {
    return CpptRanapStore.handoverList;
  }

  get loadingList(): boolean {
    return this.loadingCppt;
  }

  get stateUser() {
    return userModule.user;
  }

  get regNo(): number {
    return this.$route.params.register
      ? parseInt(this.$route.params.register)
      : this.register;
  }

  get rmNo(): string {
    return this.$route.params.rm;
  }

  get pasienRm(): string {
    return storePasien.identitasPasien?.rm
      ? storePasien.identitasPasien.rm
      : this.rmNo;
  }

  get registerKunjungan() {
    return RegisterKunjungan.register;
  }

  get isUserCanDownload() {
    return userModule.preference?.feature?.downloadCPPT;
  }

  makeNew(cat: string) {
    this.$emit("makeNewSoap", cat);
  }

  confirmPrompt(msg, fnCb) {
    const conf = confirm(msg);

    if (conf) {
      fnCb();
    }
  }

  toggleSort() {
    this.sortAscending = !this.sortAscending;
  }

  async fetchData() {
    if (!this.loadingCppt) {
      this.loadingCppt = true;
      SoapRanapStore.reset();
      CpptRanapStore.reset();
      let rsc = [];

      if (
        this.stateUser.unit_id >= "30" ||
        this.stateUser.unit_id == "01" ||
        this.loadAllCppt
      ) {
        rsc = [
          SoapRanapStore.getByRegister(this.regNo),
          CpptRanapStore.getHandoverByRegister(this.regNo),

          await CpptRanapStore.getAdimeByRegister(this.regNo),
          await CpptRanapStore.getReadbackByRegister(this.regNo)
        ];
      } else {
        rsc = [SoapRanapStore.getByRegister(this.regNo)];
      }

      await axios
        .all(rsc)
        .then(
          axios.spread((soapResp, handoverResp, adimeResp, readbackResp) => {
            //
          })
        )
        .finally(() => {
          this.loadingCppt = false;
        });

      if (this.stateUser.unit_id < "50") {
        await storeSoap.act_soap_on_reg(this.regNo);
      }

      this.$emit("fetchData");
    }
  }

  downloadCppt() {
    SoapRanapDokter.print(this.regNo);
  }

  // Event handlers from CpptListContent
  handleCopySoap(soapItem) {
    this.$emit("copySoap", soapItem);
  }

  handleEditSoap(soapItem) {
    this.$emit("editSoap", soapItem);
  }

  handleEditItem(cat, editItem) {
    this.$emit("editItem", cat, editItem);
  }
}
